import {
  // Accordion,
  // AccordionDetails,
  // AccordionSummary,
  Box,
  Divider,
  InputLabel,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { useMemo, useRef, useState } from 'react';

import { Button } from '../../../../../components/buttons';
import { AlertDialog } from '../../../../../components/dialogs';
import { Dropdown } from '../../../../../components/dropDowns';
import { APP_ENV } from '../../../../../configs';
import { IuseForm } from '../../../../../hooks/useForm';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import { DaysData } from '../../../Dashboard.types';
import ShiftTimeManagerUI from './ShiftTimeManagerUI';

export default function ShiftController({
  title = TEXT_CONTENT.MANAGE_SHIFT,
  onCancel,
  isSubmitDisabled = false,
  isUpdating = false,
  form,
  onDaySelect,
  weekDaysList = [],
  selectedStartDay,
  isLoading = false,
}: {
  title?: string;
  onCancel?: () => void;
  onDaySelect?: (v: string) => void;
  isSubmitDisabled?: boolean;
  isUpdating?: boolean;
  form: IuseForm;
  weekDaysList?: DaysData[];
  selectedStartDay?: string;
  isLoading?: boolean;
}) {
  const formRef = useRef(null);
  const [isOpenMaximumShiftLimitPrompt, setIsOpenMaximumShiftLimitPrompt] =
    useState(false);
  const { handleSubmit, formData } = form;
  const shiftDataLIst = useMemo(() => {
    const currShiftList: any[] =
      Object.values(formData)?.filter((d) => {
        const startDay = new Date(d?.baseStartDate || d.startDate)
          .getDay()
          ?.toString();
        return selectedStartDay === '' || startDay === selectedStartDay;
      }) || [];
    return {
      physicianShifts: currShiftList?.filter(
        (d) =>
          d.providerType?.toLowerCase() === 'physician' &&
          d?.status !== 'delete'
      ),
      appShifts: currShiftList?.filter(
        (d) => d.providerType?.toLowerCase() === 'app' && d?.status !== 'delete'
      ),
    };
  }, [formData, selectedStartDay]);

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const isAnyShiftExceedsMaximumLimit = Object.values(formData).some(
      (d) =>
        d?.shiftLength > APP_ENV.MAXIMUM_SHIFT_LENGTH_HR &&
        d?.status !== 'delete'
    );
    if (isAnyShiftExceedsMaximumLimit) setIsOpenMaximumShiftLimitPrompt(true);
    else {
      handleSubmit(e);
    }
  };
  const onAlertCancel = () => {
    setIsOpenMaximumShiftLimitPrompt(false);
  };
  const onAlertOk = () => {
    handleSubmit();
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          width: '90vw',
          maxWidth: '100rem',
          height: '100%',
          maxHeight: '85vh',
        }}
      >
        <form
          ref={formRef}
          name="shift-controller-form"
          onSubmit={handleFormSubmit}
        >
          <Typography
            variant="h5"
            sx={{ fontSize: '1.12rem', fontWeight: 750 }}
          >
            {title}
          </Typography>
          <Divider sx={{ mx: -2, mt: 2 }} orientation="horizontal" flexItem />
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
            <StyledFormGroup>
              <InputLabel htmlFor="shiftStartDay">Shift Start Day</InputLabel>
              <Dropdown
                id="shift-controller-day-selector"
                key="shiftStartDay"
                style={{ width: '20rem', height: '3rem' }}
                placeHolder=""
                value={selectedStartDay}
                options={weekDaysList}
                onChange={onDaySelect}
              />
            </StyledFormGroup>
          </Box>
          <Divider sx={{ mx: -2, mt: 2 }} orientation="horizontal" flexItem />
          <Typography
            variant="h5"
            sx={{ fontSize: '1.12rem', fontWeight: 750, my: 1 }}
          >
            Shift Schedule
          </Typography>
          <Divider sx={{ mx: -2, mb: 1 }} orientation="horizontal" flexItem />

          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row wrap',
              gap: 1,
              mx: -2,
              overflow: 'auto',
              maxHeight: '28rem',
              height: '100%',
              my: -1,
              py: 1,
              px: 1,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <ShiftTimeManagerUI
                isLoading={isLoading}
                shiftList={shiftDataLIst?.physicianShifts || []}
                form={form}
                shiftTypeName="Physician"
                selectedDay={selectedStartDay}
              />
            </Box>
            <Divider flexItem orientation="vertical" sx={{ my: -1 }} />
            <Box sx={{ flex: 1 }}>
              <ShiftTimeManagerUI
                isLoading={isLoading}
                shiftList={shiftDataLIst?.appShifts || []}
                form={form}
                shiftTypeName="APP"
                selectedDay={selectedStartDay}
              />
            </Box>
          </Box>

          <Divider sx={{ mx: -2, mt: 1 }} orientation="horizontal" flexItem />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 2,
              mt: 2,
            }}
          >
            <Button type="reset" onClick={onCancel} variant="outlined">
              Cancel
            </Button>
            <Button disabled={isSubmitDisabled} type="submit">
              {isUpdating ? 'Updating...' : 'Update'}
            </Button>
          </Box>
        </form>
      </Box>
      <AlertDialog
        open={!!isOpenMaximumShiftLimitPrompt}
        onOk={onAlertOk}
        okBtnText="Continue"
        onCancel={onAlertCancel}
        onClose={onAlertCancel}
        title="Are you sure?"
        desc="Some shifts exceed 12 hours. Would you like to make changes or continue?"
      />
    </>
  );
}
export const StyledFormGroup = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column',
  marginTop: '1rem',
  '& label': {
    fontSize: '1.12rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
  },
}));
export const StyledFormError = styled('span')`
  color: red;
  position: absolute;
  left: 0;
  bottom: -5px;
  // margintop: 3px;
`;
